import request from '@/utils/request'

/**
 * 获取用户收货地址列表
 * @param {Object} params 查询参数
 * @param {String} params.userId 用户ID
 * @param {Number} params.page 页码
 * @param {Number} params.row 每页条数
 * @returns {Promise} 返回Promise对象
 */
export function getUserAddressList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/userAddress.queryAdminUserAddress',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}